import {Breadcrumbs} from '@management-ui/core';
import {Paper} from '@mui/material';
import * as React from 'react';
import Table from './Table';

export default function Companies() {
  return (
    <div>
      <Breadcrumbs crumbs={[{title: 'Companies'}]}/>
      <Paper>
        <Table/>
      </Paper>
    </div>
  );
}
